import { registerPlugin } from '@capacitor/core';

export interface InsetsInfo {
  heightPx: number;
  heightDp: number;
}

export interface InsetsPlugin {
  getStatusBarHeight(): Promise<InsetsInfo>;
}

export const Insets = registerPlugin<InsetsPlugin>('Insets');
